import { Form, Input } from 'antd';
import { Search } from 'lucide-react';
import React from 'react';

function AppSearch({
  value = '',
  onChange,
  placeholder = 'Search',
  label = 'Search',
  formItemClassName = '',
  ...props
}) {
  const handleOnChange = (e) => {
    const newValue = e.target.value;
    if (onChange) onChange(newValue);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      if (onChange) onChange('');
    }
  };

  return (
    <Form.Item label={label} className={`${formItemClassName}`}>
      <Input
        placeholder={placeholder}
        value={value}
        onChange={handleOnChange}
        onKeyDown={handleKeyDown}
        allowClear
        suffix={<Search size={15} />}
        {...props}
      />
    </Form.Item>
  );
}

export default AppSearch;
